import React, { useContext, useEffect, useState } from 'react'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import { Link as MaterialLink } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import { Link, useHistory } from 'react-router-dom'

// TODO: TextField aren ot longer supported according to Google Material Design so this needs to be refactor
// https://medium.com/google-design/the-evolution-of-material-designs-text-fields-603688b3fe03

import { createUserWithEmailAndPassword, socialLogin } from 'daily-dose-common'

import { Copyright, Loading } from '..'
import { FirestoreContext } from '../../providers/firestore-provider'
import { useSelector, useDispatch } from 'react-redux'
import { IStoreState } from '../../store/types'
import { asyncError, asyncStart } from '../../ducks/ui/actions'

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(2, 0, 2),
  },
  submitWithGoogle: {
    margin: theme.spacing(0, 0, 2),
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}))

const SignUp = () => {
  const classes = useStyles()
  const history = useHistory()
  const ui = useSelector((state: IStoreState) => state.ui)
  const dispatch = useDispatch()

  const [form, setForm] = useState({
    email: '',
    password: '',
  })

  const { currentUser } = useContext(FirestoreContext)

  useEffect(() => {
    if (currentUser) {
      history.push('/sign-in')
    }
  }, [currentUser, history])
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    })
  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const { email, password } = form
    if (!!email && !!password) {
      try {
        setForm({ ...form })
        dispatch(asyncStart('USER-SIGN-UP'))
        await createUserWithEmailAndPassword(email, password)
        setForm({ email: '', password: '' })
      } catch (error) {
        setForm({
          ...form,
          password: '',
        })

        dispatch(asyncError(error.message))
      }
    }
  }

  const onSocialLogin = async (provider: 'facebook' | 'google') => {
    try {
      dispatch(asyncStart('USER-SIGN-IN'))
      await socialLogin(provider)
    } catch (error) {
      dispatch(asyncError(error.message))
    }
  }

  if (ui.loading) return <Loading />

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="header" variant="h3">
          Sign up
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <TextField
            value={form.email}
            onChange={handleChange}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            error={!!ui.error && !form.email}
          />
          <TextField
            value={form.password}
            onChange={handleChange}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            error={!!ui.error && !form.password}
            helperText={!!ui.error && !form.password && ui.error}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="default"
            className={classes.submit}
            disabled={ui.loading}
          >
            Sign Up
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="secondary"
            className={classes.submitWithGoogle}
            onClick={() => onSocialLogin('google')}
          >
            Continue with Google
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submitWithGoogle}
            onClick={() => onSocialLogin('facebook')}
          >
            Continue with Facebook
          </Button>
          <Grid container>
            <Grid item>
              <MaterialLink variant="body2" component={Link} to="sign-in">
                {'Already a member? Sign in'}
              </MaterialLink>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  )
}

export default SignUp
